
export const initialState = {
  cryptoData: [],
  total: 0,
  error: null,
};
